var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#F0F4FC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_280_411874",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 40,
    height: 40
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_280_411874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4572 43.3332C15.4016 43.3332 14.5061 42.9654 13.7705 42.2298C13.0339 41.4932 12.6655 40.5971 12.6655 39.5415V16.4582C12.6655 15.4026 13.0339 14.5065 13.7705 13.7698C14.5061 13.0343 15.4016 12.6665 16.4572 12.6665H34.9155C35.4155 12.6665 35.895 12.7637 36.3539 12.9582C36.8116 13.1526 37.2211 13.4165 37.5822 13.7498L42.2489 18.4165C42.5822 18.7776 42.8461 19.1871 43.0405 19.6448C43.235 20.1037 43.3322 20.5832 43.3322 21.0832V39.5415C43.3322 40.5971 42.9644 41.4932 42.2289 42.2298C41.4922 42.9654 40.5961 43.3332 39.5405 43.3332H16.4572ZM39.5405 21.1248L34.8739 16.4582H16.4572V39.5415H39.5405V21.1248ZM27.9989 37.8748C29.3878 37.8748 30.5683 37.3887 31.5405 36.4165C32.5128 35.4443 32.9989 34.2637 32.9989 32.8748C32.9989 31.4859 32.5128 30.3054 31.5405 29.3332C30.5683 28.3609 29.3878 27.8748 27.9989 27.8748C26.61 27.8748 25.4294 28.3609 24.4572 29.3332C23.485 30.3054 22.9989 31.4859 22.9989 32.8748C22.9989 34.2637 23.485 35.4443 24.4572 36.4165C25.4294 37.3887 26.61 37.8748 27.9989 37.8748ZM19.9989 24.7915H31.2072C31.7628 24.7915 32.2211 24.6109 32.5822 24.2498C32.9433 23.8887 33.1239 23.4304 33.1239 22.8748V19.9998C33.1239 19.4721 32.9433 19.0276 32.5822 18.6665C32.2211 18.3054 31.7628 18.1248 31.2072 18.1248H19.9989C19.4711 18.1248 19.0266 18.3054 18.6655 18.6665C18.3044 19.0276 18.1239 19.4721 18.1239 19.9998V22.8748C18.1239 23.4304 18.3044 23.8887 18.6655 24.2498C19.0266 24.6109 19.4711 24.7915 19.9989 24.7915Z",
    fill: "#3676F5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.e9439e9c7ea71416072e8227a4ed907f.svg";
export { ForwardRef as ReactComponent };